const APP_METRIC_KEY = 'software.next-gen.boards';
const BOARD_SCOPE_CRITICAL_METRIC_KEY = `${APP_METRIC_KEY}.boardscope.critical`;
const BOARD_SCOPE_CRITICAL_SLO = 1000;

export const boardScopeDataCriticalAnalyticsOptions = {
	analyticKey: BOARD_SCOPE_CRITICAL_METRIC_KEY,
	slo: BOARD_SCOPE_CRITICAL_SLO,
} as const;
